<div class="style2023 flex" style="margin-bottom: 18px; margin-top: 8px; grid-gap: 10px">
  <div style="display: flex; align-items: center" class="flex-shrink-1">
    <div style="font-weight: 600; font-size: 18px">All Orders</div>
  </div>

  <div class="flex-grow-1; flex">
    <div
      class="filter-input-container"
      style="position: relative; width: 240px; padding: 4px 10px !important"
    >
      <input
        id="orgNameInput"
        #regInput
        autofocus
        (ngModelChange)="searchTextChanged($event)"
        class="input-text"
        [ngModel]="searchText"
        autocomplete="off"
        name="regInput"
        style="width: 100%; padding-left: 20px"
        pInputText
        placeholder="Search Vehicle Reg."
        spellcheck="false"
        type="text"
      />
      <span class="fa fa-search search-icon"></span>
    </div>
    <button
      pButton
      type="button"
      icon="fa ui-icon-restore"
      class="button-style btn-sm ui-tertiary-button ml-2"
      (click)="resetVrm()"
    ></button>
  </div>
</div>

<jobs-information-list
  [jobs]="jobs"
  [busy]="isBusy"
  [isCustomerView]="true"
  [noResultsText]="'Enter vehicle registration to search for orders'"
></jobs-information-list>
